import PropTypes from 'prop-types';
import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  bar: {
    height: '15px',
    verticalAlign: 'bottom',
    display: 'flex',
    textAlign: 'center',
  },
});

const ReportTable = ({
  tableData,
}) => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>ID</StyledTableCell>
            <StyledTableCell align="left">Name/Location</StyledTableCell>
            <StyledTableCell align="right">Expertise</StyledTableCell>
            <StyledTableCell align="right">Score</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map(row => (
            <StyledTableRow key={tableData.ID}>
              <StyledTableCell align="right">{row.ID}</StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {row.Name}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                <LinearProgress className={classes.bar} variant="determinate" color="primary" value={row.Expertise} />
              </StyledTableCell>
              <StyledTableCell align="right">{row.Score}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

  );

};


ReportTable.propTypes = {
  tableData: PropTypes.object.isRequired,

};
export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/ReportTable/ReportTable.js